import _ from 'underscore';
import v5_Collection from '@/collections/v5/collection';
import Api from '@/lib/api/api';
import LoginKey from '@/models/v5/login_key';
var LoginKeys = new v5_Collection();

_.extend(LoginKeys, {
    url: function() {
        return Api.urls.login_keys();
    },
    model: LoginKey,
    /**
     * Login key creation, requires auth.
     * @param options Object
     * Pass an object with the current pass and description string of the new login key
     * {
     *  current_password: string,
     *  description: string,
     * }
     */
    create_login_key: function (options) {
        options = (options || {});
        var headers = Api.getHeaderDefaults();
        headers['X-Electricimp-Password'] = options.current_password;
        options.headers = headers;

        var data = {
            type: this.model.type,
            attributes: {
                "description": options.description,
            },
        };

        return this.create(data, options);
    },

});
export default LoginKeys;
